import styled from 'styled-components';
import { Label } from '@grnhse/seedling/lib/birch/typography';

const InlineLabel = styled(Label)`
  &.MuiFormLabel-root {
    width: auto;
  }
`;

export default InlineLabel;
